import { TrackDef } from '../track.js';

/**
 * HELION LOOP — reactor interior, intermediate.
 * A figure-eight threaded through the fusion core: banked sweepers around the
 * containment rings on both lobes, a staggered barrier chicane on the return
 * duct, and a coolant spill lurking on the west ring's exit.
 */
export const helion: TrackDef = {
  id: 'helion',
  name: 'Helion Loop',
  tagline: 'Two rings, one core — cross your own wake above the coolant decks.',
  environment: 'reactor',
  difficulty: 2,
  layout: 'circuit',
  defaultLaps: 3,
  width: 28,
  unlockLevel: 2,
  points: [
    { x: 340, y: 30, z: 220, width: 28 },
    { x: 530, y: 34, z: 110, width: 26, roll: -0.3 },
    { x: 570, y: 38, z: -130, width: 26, roll: -0.35 },
    { x: 430, y: 42, z: -320, width: 26, roll: -0.3 },
    { x: 160, y: 45, z: -330, width: 28, roll: -0.15 },
    { x: 10, y: 46, z: -80, width: 24 },
    { x: -120, y: 45, z: 60, width: 26, roll: 0.2 },
    { x: -320, y: 41, z: 180, width: 26, roll: 0.3 },
    { x: -520, y: 34, z: 120, width: 26, roll: 0.35 },
    { x: -590, y: 28, z: -90, width: 26, roll: 0.35 },
    { x: -480, y: 24, z: -290, width: 26, roll: 0.3 },
    { x: -280, y: 22, z: -350, width: 28, roll: 0.2 },
    { x: -90, y: 22, z: -230, width: 28 },
    { x: 30, y: 22, z: -20, width: 24 },
    { x: 180, y: 26, z: 180, width: 28 },
  ],
  features: [
    { kind: 'boost', s: 0.3, length: 0.007, lane: 0 },
    { kind: 'zone', s: 0.32, length: 0.09, name: 'core' },
    { kind: 'zone', s: 0.52, length: 0.09, name: 'coolant' },
    { kind: 'hazard', s: 0.55, length: 0.015, lane: 0, width: 16, type: 'slick' },
    { kind: 'boost', s: 0.63, length: 0.007, lane: -0.3 },
    { kind: 'hazard', s: 0.755, length: 0.008, lane: 0.3, width: 12, type: 'barrier' },
    { kind: 'hazard', s: 0.785, length: 0.008, lane: -0.3, width: 12, type: 'barrier' },
    { kind: 'boost', s: 0.875, length: 0.007, lane: 0.25 },
    { kind: 'boost', s: 0.96, length: 0.007, lane: 0 },
  ],
  medals: { bronze: 45.5, silver: 39.2, gold: 35, author: 32.6 },
};
